/**
 * app.routes.ts
 * -------------
 * Central route configuration for the Automated Guardrail Assessment Tool.
 */

import { Routes }    from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { stepGuard } from './core/guards/step.guard';
import { authGuard }  from './auth/auth.guard';

import { LandingComponent }
  from './pages/landing/landing.component';
import { DocumentUploadComponent }
  from './features/document-upload/document-upload.component';
import { CategoryReviewComponent }
  from './features/category-review/category-review.component';
import { AssessmentReportComponent }
  from './features/assessment-report/assessment-report.component';
import { ApplicationDetailsComponent }
  from './features/application-details/application-details.component';
import { LoginFailedComponent }
  from './pages/login-failed/login-failed.component';
import { UnauthorizedComponent }
  from './pages/unauthorized/unauthorized.component';
import { GeneralChatbotComponent }
  from './features/general-chatbot/general-chatbot.component';

export const routes: Routes = [
  // ── Landing page — protected by Entra ID login ────────────────────────
  {
    path: '',
    component: LandingComponent,
    title: 'Home',
    canActivate: [MsalGuard, authGuard],
  },

  // ── New Assessment flow ───────────────────────────────────────────────
  {
    path: 'document-upload',
    component: DocumentUploadComponent,
    title: 'Document Upload',
    canActivate: [MsalGuard, authGuard, stepGuard('document-upload')],
  },
  {
    path: 'category-review',
    component: CategoryReviewComponent,
    title: 'Category Selection',
    canActivate: [MsalGuard, authGuard, stepGuard('category-review')],
  },

  // ── Existing Assessment flow ──────────────────────────────────────────
  {
    path: 'application-details',
    component: ApplicationDetailsComponent,
    title: 'Application Details',
    canActivate: [MsalGuard, authGuard, stepGuard('application-details')],
  },

  // ── Shared — final step for both flows ────────────────────────────────
  {
    path: 'assessment-report',
    component: AssessmentReportComponent,
    title: 'Assessment Report',
    canActivate: [MsalGuard, authGuard, stepGuard('assessment-report')],
  },

  // ── General Guardrail Chatbot — standalone, no session required ───────
  {
    path: 'chat',
    component: GeneralChatbotComponent,
    title: 'General Guardrails Assistant',
    canActivate: [MsalGuard, authGuard],
  },

  // ── Auth error fallbacks ──────────────────────────────────────────────
  { path: 'login-failed',  component: LoginFailedComponent,  title: 'Login Failed' },
  { path: 'unauthorized',  component: UnauthorizedComponent, title: 'Access Denied' },

  // ── Wildcard ──────────────────────────────────────────────────────────
  { path: '**', redirectTo: '' },
];
